/* @flow */
import invariant from 'invariant';
import * as React from 'react';

import AlertDialog from 'components/AlertDialog';
import ChatActions from 'chat/actions/ChatActions';
import PotentialChatMember from 'entities/PotentialChatMember';
import { mountModal } from 'lib/modal';

export function mountIneligibilityAlert(pcm: PotentialChatMember, parent: React.Component<*, *>) {
  invariant(!pcm.isEligible(), 'mountInelgibilityAlert for eligible member');

  if (pcm.isAgeUnknown()) {
    // XXX surprising side effect, but don't want to mess during this refactor
    // from 482dd1b3 by long-gone tasti
    ChatActions.requestMemberAge(pcm);
  }

  const modal = <PotentialMemberIneligibleDialog pcm={pcm} />;

  mountModal(modal, parent);
}

export function PotentialMemberIneligibleDialog({
  pcm,
  ...dialogProps
}: {
  pcm: PotentialChatMember,
}) {
  if (pcm.isAgeUnknown() || pcm.isPending()) {
    return (
      <AlertDialog
        title="We need to collect more information from the participant"
        subtext="We'll notify you as soon as they're available for two-way messaging."
        {...dialogProps}
      />
    );
  } else if (pcm.isUnder13()) {
    return (
      <AlertDialog
        title="Two-way messaging is only available for students 13 and older."
        subtext="Don't worry—they can still receive announcements."
        {...dialogProps}
      />
    );
  } else if (pcm.isUnavailable()) {
    return (
      <AlertDialog
        title={`Sorry! ${pcm.getName()} isn't accepting messages on Remind.`}
        {...dialogProps}
      />
    );
  }
  throw new Error('PotentialMemberIneligibleDialog for eligible member');
}
export default PotentialMemberIneligibleDialog;
